import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './BackButton.scss';

export default class BackButton extends Component {
    static propTypes = {
        buttonAction: PropTypes.func.isRequired,
        buttonText: PropTypes.string
    };

    render(){
        return (
            <div className="emvio-back-button" onClick={this.props.buttonAction}>
                <div className="back-button-area">
                    <span className="icon-back" />
                    <div className="back-button-text">{this.props.buttonText ? this.props.buttonText : 'BACK'}</div>
                </div>
            </div>
        );
    }
}

